<template>
  <nav
    class="navbar navbar-default"
    style="width:100%"
  >
    <div class="container-fluid">
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle"
          :class="{toggled: $sidebar.showSidebar}"
          @click="toggleSidebar"
        >
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1" />
          <span class="icon-bar bar2" />
          <span class="icon-bar bar3" />
        </button>
        <a class="navbar-brand" :title="routeName">{{ routeName }}</a>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  data () {
    return {
      activeNotifications: false,
      alias: {
        'device_section': 'device.one',
        'device': 'device.one',
        'servers': 'server.many',
        'servers_section': 'server.many',
        'device_list': 'device.many',
        'reg': 'device.reg',
        'reports': 'report.many',
        'tasks': 'task.many',
        'usermanagment_section': 'user.management',
        'usermanagment_section_id': 'user.management',
        'user_profile': 'user.many',
        'device_groups': 'device.group.many',
        'ips': 'ip_profile.ip-address',
        "ips_section": 'ip_profile.ip-address',
        'notification_section': 'notification.many',
        'simcard_devices_section': 'simcard_devices.sim',
        'simcard_devices_list': 'simcard_devices.list',
        'simcard_devices_group_list': 'simcard_devices_group_list.many',
        'operators_api': 'operatorsAPI.main_name',
        'global_settings': 'global_settings.many',
        'global_monitoring_status': 'monitoring_status.name',
        'clients': 'client.many',
        'client_id': 'client.many',
        'supports': 'support.main',
        'support_item': 'support.main',
        'proxy_servers': 'proxy_server.many',
        'communication_management_section': 'communication_management.many',
        'simcard_profile_list': 'simcard_profile.many',
        'simcard_profile_section': 'simcard_profile.many',
        'dashboard': 'dashboard.main',
        'utilities': 'utilities.many',
        'esim_profile_list': 'esim_profile.many',
        'custom_device_list': 'custom.title',
        'models_list': 'device_models.many',
        'company_services': 'company_services.many',
        'company_services_section': 'company_services.many'

      }
    }
  },
  computed: {
    routeName () {
      if (this.$route.name === 'device_section' || this.$route.name === 'device_section_zero') {
        let dev = this.$store.getters._getDeviceById(this.$route.params.device_id);
        if (dev) {
          return this.translate('device.one') + ': ' + this.$route.params.device_id + ' (' + dev.name + ')'
        } else {
          return this.translate('device.one') + ': ' + this.$route.params.device_id
        }
      }

      if( this.$route.name === 'device_list_group' ) {
        return this.translate('device.list_group') + ': ' +this.$store.getters.getDeviceGroupById(this.$route.params.device_group_id).name
      }

      if( this.$route.name === 'simcard_devices_section' ) {
        return this.translate('simcard_devices.one') + ': ' + this.$route.params.simcard_devices_id
      }

      if( this.$route.name === 'simcard_devices_group' ) {
        return this.translate('simcard_devices.list_group') + ': ' +this.$store.getters.getSimcardDevicesGroupById(this.$route.params.simcard_devices_group_id).name
      }

      if( this.$route.name === 'simcard_profile_section' ) {
        let title = this.translate('simcard_profile.one')
        let profile = this.$store.getters.getSimcardProfileById(this.$route.params.simcard_profile_id).profile

        if (profile) {
          if (profile.parent_imsi) {
            title = title + ': ' + profile.imsi + ' (Parent: ' +  profile.parent_imsi + ')'
          } else {
            title = title + ': ' +  profile.imsi
          }
        }

        return title
      }

      if( this.$route.name === 'esim_profile_section' ) {
        let title = this.translate('esim_profile.one')
        let profile = this.$store.getters.getEsimProfileById(this.$route.params.esim_profile_id).profile

        if (profile) {
          if (profile.parent_imsi) {
            title = title + ': ' + profile.imsi + ' (Parent: ' +  profile.parent_imsi + ')'
          } else {
            title = title + ': ' +  profile.imsi
          }
        }

        return title
      }

      if (this.alias[this.$route.name] !== undefined) {
        return this.translate(this.alias[this.$route.name])
      }

      return ''
    }
  },
  methods: {
    capitalizeFirstLetter (string) {
      if (string !== undefined) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    }
  }
}

</script>
<style>

</style>
